export const ON_INTL_NETWORK = 'cf-intl-network';
